import * as React from 'react';

const BuyerProtectionShield32 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    fillRule: "evenodd",
    d: "M32 16c0 8.836-7.163 16-16 16-8.836 0-16-7.164-16-16C0 7.163 7.164 0 16 0c8.837 0 16 7.163 16 16",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    fillRule: "evenodd",
    d: "M16 24s-6.667-2.4-6.667-8v-5.6L16 8l6.667 2.4V16c0 5.6-6.667 8-6.667 8",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    fillRule: "evenodd",
    d: "m15.468 18.528-3.135-3.093 1.076-1.06 2.059 2.032 3.79-3.74 1.075 1.06-4.865 4.8Z",
    clipRule: "evenodd"
  }
));
BuyerProtectionShield32.Size = 32;
BuyerProtectionShield32.Title = "BuyerProtectionShield";

export { BuyerProtectionShield32 as default };
